<template>
	<component
	:is="tag"
	v-bind="$attrs"
	role="button" class="
	group
	hover:outline 
	outline-gray-300
	active:outline-red-600 
	outline-2
	rounded-lg
	border
	border-2"
	:class="styleOverride?'':style+' '+styleBorder">
	
		
		<div class="
		h-fit
	flex flex-none flex-col 
	justify-center
	
	
			items-center" >
			<div class="flex
			content-stretch
			items-stretch
			gap-1 grow ">
			<img v-if="estructura" class='flex-none object-contain h-6 w-6 md:h-8 md:w-8 ' :class="styleOverride?'brightness-0':c.color.brightness" :src="require('@/assets/estructures/ico/ico'+c.img)"/>
			
			<Pisos :castell="c.normalitzat[0]" class="pt-1 h-auto" :color="c.color.brightness=='brightness-0'?'border-black':'border-white'" mida="nano" :hAuto="true"/>
					
			
			<div class="flex flex-col
			items-center justify-between
			w-fit  group-active:bg-gray-200 group-hover:bg-gray-200 h-full rounded-[0.4rem] text-black p-1 w-full"
			:class="c.resultat=='d'
			? 'bg-white'
			: styleResultat">
				<span class="inline-flex items-center gap-1 flex-nowrap">
					<font-awesome-icon v-if="universitaria" :icon="['fas','graduation-cap']" class="opacity-60" /><p>
					<strong>{{ c.etiqueta }}</strong></p>
					<div v-if="c.resultat!=='d'" class="p-1 aspect-square h-5 font-bold rounded flex items-center justify-center mr-1 bg-black text-white" >{{ c.resultat }}</div>
					<img v-if="novetat" class="h-4 w-4 drop-shadow" :src="Novetat"/>
				</span>
				
			<p  v-if="data"  class="opacity-60 text-sm">{{ data }}</p>
			</div>
		</div>
			<!--<p v-if="estrelles" class="text-sm text-center h-4 flex items-center">{{ c.estrelles }}</p>-->
			<p v-if="estrelles"><EstrellesFA class="text-[0.65rem] text-center h-4 flex items-center" :gamma="c.gamma"/>
      </p>
			<div v-if="punts" class="flex w-full h-4 text-white font-bold text-xs justify-around text-nowrap gap-1 mt-1">
				<p class="bg-resultat-descarregat rounded flex items-center px-1">d: {{c.punts.descarregat}}</p>
				<p class="bg-resultat-carregat rounded flex items-center px-1">c: {{c.punts.carregat}}</p>
			</div><div v-if="puntuat" class="flex w-full h-4 text-white font-bold text-xs justify-around text-nowrap mt-1">
				<p  v-if="c.resultat=='d'" class="bg-resultat-descarregat rounded flex items-center px-1">{{c.puntuat}}</p>
				<p  v-if="c.resultat=='c'" class="bg-resultat-carregat rounded flex items-center px-1"> {{c.puntuat}}</p>
				<p  v-if="c.resultat=='i'" class="bg-resultat-intent rounded flex items-center px-1"> {{c.puntuat}}</p>
				<p  v-if="c.resultat=='id'" class="bg-resultat-desmuntat rounded flex items-center px-1"> {{c.puntuat}}</p>
			</div>
		</div>
    </component>
</template>
<script setup>
import {defineProps} from 'vue';
import castell from '@/functions/notacioCastell.js';
import EstrellesFA from './EstrellesFA.vue';
import Novetat from '@/assets/novetat.svg'
import Pisos from './Pisos.vue';

const props=defineProps({
	tag:{
		type:String,
		default:'div'
	},
    castell:{
        type:String,
        default:"pd4"
    },
    universitaria:{
        type:Boolean,
        required:false,
        default:false
    },
	estrelles:{
        type:Boolean,
        required:false,
        default:true
	},
	punts:{
        type:Boolean,
        required:false,
        default:false
	},
	estructura:{
        type:Boolean,
        required:false,
        default:true
	},
	compacte:{
        type:Boolean,
        required:false,
        default:false
	},
	puntuat:{
        type:Boolean,
        required:false,
        default:false
	},
	novetat:{
        type:Boolean,
        required:false,
        default:false
	},
	styleOverride:{
        type:Boolean,
        required:false,
        default:false
	},
	data:{
        type:String,
        required:false,
    }
});


const c = castell(props.castell,props.universitaria);
const style= ' bg-'+c.color.gamma+' text-'+c.color.text;
const styleBorder= ' border-'+c.color.gamma;
const styleResultat = 'border-2 border bg-'+c.color.resultat+'_l border-'+c.color.resultat
</script>